export * as Avatar from './index.parts.js';